import { Component, Host, HostBinding, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../../shared-components/user/user.service';
import { Link, NewLink } from '../link.model';
import { YearService } from '../../../shared-components/year/year.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../../shared-modules/login/login.service';

@Component({
  selector: 'app-add-link',
  templateUrl: './add-link.component.html'
})
export class AddLinkComponent implements OnInit {
  @HostBinding('class.sis-app-root') sisAppRoot: Host = true;
  linkName: string;
  linkUrl: string;
  V10: boolean;
  usingHttps = false;
  addLinkForm: FormGroup;
  nameErrorMessage = 'Required Field';
  constructor(private loginService: LoginService, private dialogRef: MatDialogRef<AddLinkComponent>, private userService: UserService, private yearService: YearService) {
  }

  ngOnInit() {
    this.V10 = this.loginService.LoginSettings.V10;
    this.addLinkForm = new FormGroup({
      'name': new FormControl(null, [
        Validators.required,
        Validators.maxLength(50)
      ]),
      'url': new FormControl(null, [
        Validators.required,
      ])
    });
    this.onChanges();
  }

  onChanges(): void {
    this.addLinkForm.valueChanges.subscribe(val => {
      this.linkName = val['name'];
      this.linkUrl = val['url'];
      if (this.linkName && this.linkName.length > 50) {
        this.nameErrorMessage = 'Name must be 50 characters or less';
      } else {
        this.nameErrorMessage = 'Required Field';
      }
    });
  }

  cancelClick() {
    // POST: Close Dialog
    this.dialogRef.close();
  }

  saveClick() {
    if (this.addLinkForm.invalid) {
      // mark controls as touched
      this.addLinkForm.controls['name'].markAsTouched();
      this.addLinkForm.controls['url'].markAsTouched();
    } else {
      // POST: Create new link, Post to the server, update links stored in service, close the dialog
      const link: NewLink = new NewLink();
      link.Description = this.linkName;
      link.Id = -1;
      link.LinkToolTip = '';
      link.OpenAsHTTPS = this.usingHttps;
      link.OpenAsNewWindow = false;
      link.QuickJumpDescription = '';
      link.Sequence = 0;
      link.WebAddress = this.linkUrl;
      this.userService.saveLink(link).subscribe(response => {
      }, err => {
        console.log(err);
      }, () => {
        // Get the new set of links
        if (this.V10) {
          this.getUserLinks(this.userService.userId, this.yearService.defaultYear.AYIdentifier);
        }
        else {
          this.getUserLinks(0, this.yearService.defaultYear.Id);
        }
      });
    }
  }

  getUserLinks(id: number, yearId: any) {
    const linkList: Link[] = [];
    if (this.V10) {
      // v10
      if (this.userService.userType != 1) {
        // Parent/Student
        this.userService.getParentStudentLinks(id, yearId).subscribe(response => {
          // create a new link object for each object in the response body
          if (response.body != null) {
            for (let i = 0; i < response.body.length; i++) {
              const bLink = response.body[i];
              const link = new Link();
              link.LinkName = bLink.Description;
              link.Link_ID = bLink.Id;
              link.OpenAsHTTPS = bLink.OpenAsHTTPS;
              link.OpenAsNewWindow = bLink.OpenAsNewWindow;
              link.LinkUrl = bLink.WebAddress;
              link.IsDistrictLevel = 'Yes';
              linkList.push(link);
            }
            this.userService.links = linkList;
          }
        });
      } else {
        // Staff
        this.userService.getLinks(id, 0, yearId).subscribe(response => {
          this.userService.links = response.body;
        });
      }
    } else {
      // v9
      this.userService.getParentStudentLinks(id, yearId).subscribe(response => {
        // create a new link object for each object in the response body
        if (response.body != null) {
          for (let i = 0; i < response.body.length; i++) {
            const bLink = response.body[i];
            const link = new Link();
            link.LinkName = bLink.Description;
            link.Link_ID = bLink.Id;
            link.OpenAsHTTPS = bLink.OpenAsHTTPS;
            link.OpenAsNewWindow = bLink.OpenAsNewWindow;
            link.LinkUrl = bLink.WebAddress;
            link.IsDistrictLevel = 'No';
            linkList.push(link);
          }
          this.userService.links = linkList;
        }
      });
    }
    this.dialogRef.close();
  }
}
